import { StateKey } from 'common/utils/flipState'
import { isErrorRejected } from 'common/utils/ajax/apiErrorHandler'
import HttpStatus from 'common/utils/httpStatus'
import logger from 'common/logger'
import { MY_PAY_DEFAULT_VALUE } from '../../constants/naverPay'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

const initialState: string = MY_PAY_DEFAULT_VALUE

const FETCH_MY_POINTS = 'my/FETCH_MY_POINTS'

export const fetchMyPoints = (curState: StateKey, headers?: any) => async dispatch => {
  try {
    const response = await axios.get('/v1/pay/points', {
      ...getHeaders(headers),
      data: {
        [isErrorRejected]: true,
      },
    })
    dispatch({
      curState,
      type: FETCH_MY_POINTS,
      points: response && response.data,
    })
  } catch (err) {
    err.response.status !== HttpStatus.UNAUTHORIZED && logger.error(err)
    dispatch({
      curState,
      type: FETCH_MY_POINTS,
      points: initialState,
    })
  }
}

const myPointReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MY_POINTS:
      return action.points
    default:
      return state
  }
}

export default myPointReducer
